import Head from './../components/Head';
import dayjs from 'dayjs';
import Footer from '../components/Footer.vue';
import { Empty } from 'zhs-components';
export default {
  created() {
    this.getNewsTypeList();
    this.getNewsList();
  },

  components: {
    Head,
    Footer,
    Empty
  },

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      newsList: [],
      newsTypeList: [],
      pageInfo: {
        pageIndex: 1,
        rows: 0,
        pageLimit: 10,
        newsTypeId: ''
      },
      newsName: '',
      showSearchResult: false,
      title: '',
      menuInfo: {}
    };
  },

  methods: {
    async getNewsTypeList() {
      const newsTypeList = await this.$http.getNewsClass({
        menu_id: this.menuId
      });
      console.log('分类', newsTypeList);
      this.newsTypeList = newsTypeList.content;
    },

    async getNewsList() {
      const params = {
        '_pageable.page': this.pageInfo.pageIndex - 1,
        '_pageable.size': this.pageInfo.pageLimit,
        menu_id: this.menuId,
        news_name: this.newsName || undefined,
        classify_id: this.pageInfo.newsTypeId || undefined
      };
      const res = await this.$http.getNewsList(params);
      console.log('新闻列表', res);
      this.newsList = res.content;
      this.pageInfo.rows = +res.totalElements;
    },

    // 切换分页
    pageIndexChange(current) {
      this.pageInfo.pageIndex = current;
      this.getNewsList();
    },

    // 搜索
    handleSearch(newsTypeId = '') {
      this.pageInfo.pageIndex = 1;
      this.pageInfo.newsTypeId = newsTypeId;
      this.getNewsList();
      this.showSearchResult = true;
    },

    // 关键字高亮
    kewordFilter(value) {
      if (!value) return '';
      if (!this.newsName) return value;
      let reg = new RegExp(this.newsName, 'g');
      return value.replace(reg, `<span class="theme-color">${this.newsName}</span>`);
    },

    // 格式化新闻内容
    formateNews(data) {
      let result = this.$utils.getContentText(data);
      return this.kewordFilter(result);
    },

    // 增加观看次数
    async addViewCount(id) {
      const res = await this.$http.addViewCount({
        id
      }, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      console.log("count", res);
    },

    // 点击卡片进去详情页
    showNewsDetail(item) {
      if (item.news_type === 1) {
        window.location.href = `/noticeDetail.html?id=${item.id}&menuId=${this.menuId}&name=${this.menuInfo.nav_name}`;
      } else {
        this.addViewCount(item.id);
        window.open(item.news_url);
      }
    },

    dayjs
  }
};